import styled from 'styled-components'
import {
  textStyleWeightOptions,
  textStyleSizeStyleOptions,
  textStyleWeightStyleOptions
} from '../../fundamentals/text-styles/constants'
import colorsOptions from '../../fundamentals/colors-styles/constants'

export const NotFoundContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.25rem;
  max-width: 240px;
`

export const NotFoundIcon = styled.div`
  margin-bottom: 1rem;
`

export const NotFoundHeader = styled.span`
  ${({ size }) => textStyleSizeStyleOptions[size]}};
  ${textStyleWeightStyleOptions[textStyleWeightOptions['TEXT-700']]};
  color: ${colorsOptions.greys['grey-50']};
  text-align: center;
`

export const NotFoundDescription = styled.div`
   ${({ size }) => textStyleSizeStyleOptions[size]}};
  ${textStyleWeightStyleOptions[textStyleWeightOptions['TEXT-500']]};
  max-width: 512px;
  text-align: center;
  color: ${colorsOptions.greys['grey-50']};
`
